var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "white" },
    [
      _c("div", { attrs: { id: "activity" } }),
      _vm._v(" "),
      _vm.hotList.length
        ? _c("comment", {
            attrs: {
              title: "热门评论",
              list: _vm.hotList,
              listName: "hotList",
              isAdmin: _vm.isAdmin,
              currentUserName: _vm.userObj.nickname,
              canLoad: true
            },
            on: {
              toPraise: _vm.toPraise,
              del: _vm.del,
              replyComment: _vm.replyComment,
              toDetails: _vm.toDetails
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.hotList.length ? _c("div", { staticClass: "blank" }) : _vm._e(),
      _vm._v(" "),
      _c("div", { ref: "newComment", attrs: { id: "newComment" } }),
      _vm._v(" "),
      _vm.newList.length
        ? _c("comment", {
            attrs: {
              title: "最新评论",
              list: _vm.newList,
              listName: "newList",
              isAdmin: _vm.isAdmin,
              currentUserName: _vm.userObj.nickname,
              canLoad: _vm.canLoad,
              pageOver: _vm.pageOver
            },
            on: {
              toPraise: _vm.toPraise2,
              del: _vm.del2,
              replyComment: _vm.replyComment,
              toDetails: _vm.toDetails
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "total flex-center", class: { show: _vm.fixStyle } },
        [
          _c(
            "section",
            { staticClass: " flex-center", on: { click: _vm.toInput } },
            [
              _c("img", {
                staticClass: "icon",
                attrs: { src: require("../img/mes.png"), alt: "" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _vm._v("评论(" + _vm._s(_vm.commentNum) + ")")
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "line" }),
          _vm._v(" "),
          _c(
            "section",
            {
              staticClass: "flex-center",
              class: { active: _vm.isPraise },
              on: { click: _vm.praiseArticle }
            },
            [
              _c("div", {
                staticClass: "bg",
                class: { active: _vm.showAnimate }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _vm._v("点赞(" + _vm._s(_vm.praiseNum) + ")")
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.noData
        ? _c("div", { staticClass: "no-mes" }, [_vm._v("快来抢个沙发吧")])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "margin" }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.inputShow,
              expression: "inputShow"
            }
          ],
          staticClass: "mask flex-center input-box"
        },
        [
          _c("div", {
            staticClass: "flex1",
            staticStyle: { width: "100%" },
            on: { click: _vm.hideInput }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "input-bg flex-center" }, [
            _c("section", { staticClass: "flex-center flex1" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.comment,
                    expression: "comment"
                  }
                ],
                ref: "textarea",
                staticClass: "input2",
                attrs: {
                  type: "text",
                  id: "textarea",
                  placeholder: _vm.placeholder
                },
                domProps: { value: _vm.comment },
                on: {
                  blur: _vm.gotoView,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.comment = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "btn", on: { click: _vm.send } }, [
              _vm._v("发送")
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("confirm", {
        attrs: { "show-confirm": _vm.showConfirm },
        on: { sure: _vm.sure, cancel: _vm.cancel }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }